import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { SmoothScroll } from "@/components/layout/SmoothScroll";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { WhatsAppButton } from "@/components/layout/WhatsAppButton";
import { PageTransition } from "@/components/motion/PageTransition";
import Home from "@/pages/Home";
import ParcoMezzi from "@/pages/ParcoMezzi";
import Categoria from "@/pages/Categoria";
import Mezzo from "@/pages/Mezzo";
import Noleggio from "@/pages/Noleggio";
import Trasporto from "@/pages/Trasporto";
import Contatti from "@/pages/Contatti";
import NotFound from "@/pages/NotFound";

const AnimatedRoutes = () => {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait" initial={false}>
      <PageTransition key={location.pathname}>
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/parco-mezzi" element={<ParcoMezzi />} />
          <Route path="/parco-mezzi/:categoria" element={<Categoria />} />
          <Route path="/parco-mezzi/:categoria/:slug" element={<Mezzo />} />
          <Route path="/servizi" element={<Noleggio />} />
          <Route path="/servizi/noleggio" element={<Noleggio />} />
          <Route path="/servizi/trasporto" element={<Trasporto />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </PageTransition>
    </AnimatePresence>
  );
};

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <SmoothScroll>
          <Navbar />
          <AnimatedRoutes />
          <Footer />
          <WhatsAppButton />
          <Toaster position="bottom-center" richColors toastOptions={{ style: { fontFamily: '"Plus Jakarta Sans", sans-serif' } }} />
        </SmoothScroll>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
